import { Routes } from '@angular/router';

import { authGuard } from '../shared/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'app',
    loadChildren: () =>
      import('../protected-area/protected-area.routes').then(
        (m) => m.PROTECTED_ROUTES
      ),
    canActivate: [authGuard],
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('../public-area/public-area.routes').then((m) => m.PUBLIC_ROUTES),
  },
  {
    path: '',
    redirectTo: 'app',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'app',
  },
];
